import React, { Component, createRef } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import {
  Paper,
  Accordion,
  AccordionSummary,
  // Chip,
  Grid,
  Typography,
  Button,
  Drawer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Carousel from "react-material-ui-carousel";
import { openAlertBox } from "../../../../common/AlertMessage/AlertMessage";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import QRCode from "react-qr-code";
import { getStorageItem } from "../../../../common/localStorage";
import { apiData } from "../../../../common/common-types";
import { stockAPI } from "../../../../common/axiosInstance";
import filter from "../../../../assets/icons/redeem/filter.svg";
import PrivilegeFilter from "./PrivilegeFilter";
import { truncateHTMLWithStructure } from "../../../../utils";
import Loader from "../../../../components/Loader/Loader";
import Theme, { globalBackground } from "../../../../components/UI/Theme";
import NoRecordFound from "../../../../components/NoRecordFound/NoRecordFound";
import LoyaltyInfo from "../../Transactions/components/LoyaltyInfo";

const styles = (theme) => {
  return {
    btnContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: "10px",
      paddingBottom: "10px",
    },

    secondaryHeading: {
      color: "#898989",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      fontSize: "16px",
      padding: "0",
      margin: "0",
      [theme.breakpoints.down(768)]: {
        fontSize: "14px",
        lineHeight: "1.4",
      },
      [theme.breakpoints.down(480)]: {
        fontSize: "13px",
        linxxeHeight: "1.3",
      },
      "& ul": {
        paddingBottom: "0px !important",
        marginBottom: "0px !important",
      },
    },

    fontSizeResponsive: {
      fontSize: "16px",
      [theme.breakpoints.down("641")]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down("481")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down("381")]: {
        fontSize: "10px",
      },
    },
    numBox: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#000",
      marginTop: "8px",
    },

    img: {
      width: "100%",
      height: "auto",
      borderRadius: "6px",
      // objectFit: "contain",
      padding: " 0px 5px 0px 0px",
      display: "block",

      [theme.breakpoints.up("sm")]: {
        height: "60px",
        padding: " 0px 5px 0px 0px",
        // objectFit: "contain",
      },

      [theme.breakpoints.up("md")]: {
        height: "70px",
        padding: " 0px 5px 0px 0px",
        // objectFit: "contain",
      },
      [theme.breakpoints.up("lg")]: {
        height: "70px",
        width: "100%",
        // objectFit: "contain",
      },
    },

    disabled: {
      opacity: 0.5,
    },
    panelDetail: {
      // display: "flex",
      justifyContent: "center",
      // flexDirection: "column",
      alignItems: "center",
      padding: "10px 10px",
      textAlign: "center",
    },
    filterDropdown: {
      zIndex: 1,
      textTransform: "none",
    },

    detail: {
      padding: "0px 0 0 10px",
      display: "flex",
      justifyContent: "space-between",
    },
    benifit: {
      fontSize: "18px",
      textAlign: "justify",
      [theme.breakpoints.down("481")]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down("421")]: {
        fontSize: "13.5px",
      },
      [theme.breakpoints.down("401")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down("381")]: {
        fontSize: "12.5px",
      },
      [theme.breakpoints.down("361")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down("321")]: {
        fontSize: "10px",
      },
    },
    privilegeRowWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "15px",
      paddingTop: "20px",
      borderBottom: "1px solid #fece73",
      [theme.breakpoints.down(768)]: {
        padding: "12px 10px",
        paddingTop: "15px",
      },
      [theme.breakpoints.down(480)]: {
        padding: "10px 8px",
        paddingTop: "12px",
      },
    },
    privilegeHeadBox: {
      display: "flex",
      alignItems: "center",
    },
    panelIcon: {
      color: theme.palette.commonIcon.golden,
      fontWeight: "bold",
      marginBottom: 2,
      marginRight: 4,
    },

    gradientChipWrapper: {
      padding: "3px", // thickness of the border
      borderRadius: "16px", // match chip border radius
      // backgroundColor: theme.palette.commonIcon.golden,
      display: "inline-block",
      width: "fit-content",
    },
    validityPeriod: {
      backgroundColor: "#FFF",
      color: theme.palette.primary.main,
      // border: `.5px solid ${theme.palette.primary.main}`,
      width: "fit-content",
      marginTop: "1px",
      marginBottom: "1px",
    },
    filter_icon_container: {
      position: "relative",
      padding: 0,
      borderRadius: 0,
      overflow: "auto",
      display: "inline-block",
      height: "100%",
      color: theme.palette.commonIcon.golden,
      margin: 0,
    },
    filter_dot: {
      borderRadius: "50%",
      position: "absolute",
      top: 0,
      right: 0,
      zIndex: 20,
      backgroundColor: theme.palette.commonIcon.golden,
      width: "11px",
      height: "11px",
      [theme.breakpoints.down("xs")]: {
        width: "8px",
        height: "8px",
      },
    },
    icon_container: {
      display: "flex",
      justifyContent: "flex-end",
    },
    filterIconCss: {
      backgroundColor: theme.palette.commonIcon.golden,
      " -webkit-mask-image": `url(.${filter})`,
      "mask-image": `url(.${filter})`,
      mask: `url(.${filter}) no-repeat center / contain`,
      "-webkit-mask": `url(.${filter}) no-repeat center / contain`,
    },
    cardIcons: {
      width: "22px",
      height: "22px",
      display: "inline-block",
      transition: ".12s",
      "-webkit-mask-size": "cover",
      "mask-size ": "cover",
      marginLeft: "2rem",
      // float: 'right',
      [theme.breakpoints.down("xs")]: {
        width: "25px",
        height: "25px",
        marginLeft: "1rem",
      },
    },
    root: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    navButton: {
      "&.MuiIconButton-root": {
        backgroundColor: "#3077AC !important",
        opacity: "1 !important",
        "&:hover": {
          backgroundColor: "#3077AC !important",
          opacity: "1 !important",
        },
        "&.Mui-disabled": {
          backgroundColor: "#3077AC !important",
          opacity: "1 !important",
          "&:hover": {
            backgroundColor: "#3077AC !important",
            opacity: "1 !important",
          },
        },
      },
    },
    expiryDate: {
      // color: "#454545",
      fontSize: "14px",
      [theme.breakpoints.down(641)]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down(481)]: {
        fontSize: "11px",
        height: "13px",
      },
      [theme.breakpoints.down(421)]: {
        fontSize: "10.5px",
      },
      [theme.breakpoints.down(401)]: {
        fontSize: "10px",
      },
      [theme.breakpoints.down(381)]: {
        fontSize: "9.5px",
      },
      [theme.breakpoints.down(361)]: {
        fontSize: "9px",
        height: "11px",
      },
      [theme.breakpoints.down(321)]: {
        fontSize: "8px",
      },
    },

    goldGradientBox: {
      position: "relative",
      border: "1px solid #FECE73",
      background: theme.palette.commonIcon.golden,
      "& > root": {
        borderRadius: "12px",
        backgroundColor: "#fff",
        padding: "5px",
        width: "100%",
        height: "100%",
      },
    },
  };
};

const options = [
  { name: "Active", val: 1 },
  { name: "Expired", val: 0 },
];

class Privilege extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      innerExpanded: false,
      pointsSelection: 0,
      selectedIndex: 1,
      privilegeArray: [
        { name: "This Month", val: 1 },
        { name: "Last Month", val: 2 },
        { name: "This Quarterly", val: 3 },
        { name: "Half Yearly", val: 4 },
        { name: "This Year", val: 5 },
        { name: "Last Year", val: 6 },
      ],
      open: false,
      openLocation: false,
      openDetailLocation: false,
      privilegeData: [],
      locationData: [{ id: "all", location_name: "All" }],
      detailLocationData: [{ id: "", location_name: "All" }],
      selectedLocationId: "all",
      selectedDetailLocationId: "",
      privilegeDataByLocation: [],
      privilegeLoaded: false,
      selectedDetailLocations: [],
      selectLocId: "",
      filterApplied: false,
      appliedLocationId: "all",
      appliedStatusId: 1,
      activeStep: 0,
      // Add state for the dialog
      dialogOpen: false,
      dialogMessage: "",
      benefitsModalOpen: false,
      benefitsZoom: 1,
      shopIdParam: null,
    };

    this.anchorRef = createRef();
    this.anchorRefLocation = createRef();
    this.anchorRefDetailLocation = createRef({});
  }

  convertDate = (expiryDate) => {
    const moment = require("moment");
    const today = moment(expiryDate);
    return today.format("Do MMM'YY");
  };

  // handleToggle = (e) => {
  //   e.stopPropagation();
  //   this.setState((prevState) => ({
  //     open: !prevState.open,
  //   }));
  // };

  // handleClose = (e) => {
  //   if (this.anchorRef.current && this.anchorRef.current.contains(e.target)) {
  //     return;
  //   }
  //   this.setState({ open: false });
  // };

  // handleToggleLocation = (e) => {
  //   e.stopPropagation();
  //   this.setState((prevState) => ({
  //     openLocation: !prevState.openLocation,
  //   }));
  // };

  // handleCloseLocation = (e) => {
  //   if (
  //     this.anchorRefLocation.current &&
  //     this.anchorRefLocation.current.contains(e.target)
  //   ) {
  //     return;
  //   }
  //   this.setState({ openLocation: false });
  // };

  // handleToggleDetailLocation = (e) => {
  //   e.stopPropagation();
  //   this.setState((prevState) => ({
  //     openDetailLocation: !prevState.openDetailLocation,
  //   }));
  // };

  // handleCloseDetailLocation = (e) => {
  //   if (
  //     this.anchorRefDetailLocation.current &&
  //     this.anchorRefDetailLocation.current.contains(e.target)
  //   ) {
  //     return;
  //   }
  //   this.setState({ openDetailLocation: false });
  // };

  handleMenuItemClick = (e) => {
    let index = e.target.value;
    e.stopPropagation();
    this.setState(
      {
        selectedIndex: index,
        open: false,
        innerExpanded: false,
      }

      // async () => {
      //   const user = JSON.parse(getStorageItem("user"));
      //   const privilegePayload = new FormData();

      //   privilegePayload.append("customer_id", user.id);
      //   privilegePayload.append("platform", apiData.platform);
      //   privilegePayload.append("merchant_id", apiData.merchant_id);
      //   // privilegePayload.append("filter_type", index + 1);
      //   privilegePayload.append("status", options[index]?.val);

      //   const privilegs = await stockAPI(
      //     privilegePayload,
      //     "POST",
      //     "/getCustomerPrivilegeVouchersList"
      //   );

      //   if (this.state.selectedLocationId == "") {
      //     this.setState({
      //       privilegeData: privilegs ? privilegs : {},
      //       privilegeDataByLocation: privilegs ? privilegs : {},
      //     });
      //   } else {
      //     let updatedPrivilegeData = privilegs.filter((data) =>
      //       data.locations.some(
      //         (location) => location.id == this.state.selectedLocationId
      //       )
      //     );
      //     this.setState({
      //       privilegeData: privilegs ? privilegs : {},
      //       privilegeDataByLocation: updatedPrivilegeData
      //         ? updatedPrivilegeData
      //         : {},
      //     });
      //   }
      //   this.props.openLoader(false);
      // }
    );
  };

  handleMenuItemClickLocation = (e) => {
    let id = e.target.value || "";
    e.stopPropagation();
    this.setState(
      {
        selectedLocationId: id,

        openLocation: false,
        innerExpanded: false,
      }

      // async () => {
      //   if (id == "") {
      //     this.setState({
      //       privilegeDataByLocation: this.state.privilegeData
      //         ? this.state.privilegeData
      //         : {},
      //     });
      //   } else {
      //     let updatedPrivilegeData = this.state.privilegeData.filter((data) =>
      //       data.locations.some((location) => location.id == id)
      //     );
      //     this.setState({
      //       privilegeDataByLocation: updatedPrivilegeData
      //         ? updatedPrivilegeData
      //         : {},
      //     });
      //   }

      //   this.props.openLoader(false);
      // }
    );
  };

  // handleMenuItemClickDetailLocation = (e) => {
  //   e.stopPropagation();
  //   console.log(e.target.value);
  //   // console.log(e.target.value);
  //   // this.setState(
  //   //   {
  //   //     selectedDetailLocationId: e.target.value,
  //   //     openDetailLocation: false,
  //   //   }

  //   // async () => {
  //   //   if (id == "") {
  //   //     this.setState({
  //   //       privilegeDataByLocation: vouchersData
  //   //         ? eVouchersData
  //   //         : {},
  //   //     });
  //   //   } else {
  //   //     let updatedPrivilegeData = this.state.privilegeData.filter((data) =>
  //   //       data.locations.includes(id)
  //   //     );
  //   //     this.setState({
  //   //       privilegeDataByLocation: updatedPrivilegeData
  //   //         ? updatedPrivilegeData
  //   //         : {},
  //   //     });
  //   //   }

  //   //   this.props.openLoader(false);
  //   // }
  //   // );
  // };

  // handleMenuItemClickDetailLocationValue = (e, id) => {
  //   e.stopPropagation();
  //   console.log(id);
  //   // console.log(e.target.value);
  //   this.setState({
  //     selectedDetailLocationId: id,
  //     openDetailLocation: false,
  //   });
  // };

  handleGetEvoucherCode = async (e, orderDetails) => {
    e.stopPropagation();
    // async () => {
    if (orderDetails.location_id === "") {
      // if (this.state.selectedDetailLocationId == "") {
      openAlertBox("Please select specific location", "error");
    } else {
      const user = JSON.parse(getStorageItem("user"));
      const evoucherPayload = new FormData();

      evoucherPayload.append("customer_id", user.id);
      evoucherPayload.append("platform", apiData.platform);
      evoucherPayload.append("merchant_id", apiData.merchant_id);
      evoucherPayload.append("order_details", JSON.stringify(orderDetails));

      const evouchers = await stockAPI(evoucherPayload, "POST", "/placeOrder");
      // this.setState({
      //   eVouchersData: evouchers ? evouchers : {},
      // });

      // user = JSON.parse(getStorageItem("user"));

      if (evouchers) {
        const privilegePayload = new FormData();
        privilegePayload.append("customer_id", user.id);
        privilegePayload.append("platform", apiData.platform);
        privilegePayload.append("merchant_id", apiData.merchant_id);
        // privilegePayload.append("filter_type", this.state.selectedIndex + 1);
        privilegePayload.append("status", this.state.selectedIndex);

        const privilegs = await stockAPI(
          privilegePayload,
          "POST",
          "/getCustomerPrivilegeVouchersList"
        );

        if (privilegs) {
          if (this.state.selectedLocationId == "all") {
            this.setState({
              privilegeData: privilegs ? privilegs : {},
              privilegeDataByLocation: privilegs ? privilegs : {},
            });
          } else {
            let updatedPrivilegeData = privilegs.filter((data) =>
              data.locations.some(
                (location) => location.id == this.state.selectedLocationId
              )
            );
            this.setState({
              privilegeData: privilegs ? privilegs : {},
              privilegeDataByLocation: updatedPrivilegeData
                ? updatedPrivilegeData
                : {},
            });
          }
        }
      }
    }

    this.props.openLoader(false);
    // };
  };

  handleInnerChange =
    (panel, detailLocationList, locationId) => (event, isExpanded) => {
      this.setState({
        selectLocId: locationId,
        innerExpanded: isExpanded ? panel : false,
        selectedDetailLocationId: detailLocationList[0]?.id,
      });
    };

  // handlePrivilegeChange = (e) => {
  //   const value = e.target.value;
  //   this.setState({
  //     pointsSelection: value,
  //   });
  // };

  async componentDidMount() {
    await this.setDefaultParam();
    this.props.openLoader(true);
    this.getBenefitTabData();
    var user;
    var ptShortName;

    if (getStorageItem("user")) {
      user = JSON.parse(getStorageItem("user"));
      ptShortName = getStorageItem("pointShortName")
        ? getStorageItem("pointShortName")
        : "P";

      const privilegePayload = new FormData();
      privilegePayload.append("customer_id", user.id);
      privilegePayload.append("platform", apiData.platform);
      privilegePayload.append("merchant_id", apiData.merchant_id);
      // privilegePayload.append("filter_type", this.state.selectedIndex + 1);
      privilegePayload.append("status", this.state.selectedIndex);

      const locationPayload = new FormData();
      locationPayload.append("customer_id", user.id);
      locationPayload.append("platform", apiData.platform);
      locationPayload.append("merchant_id", apiData.merchant_id);
      // console.log(user);
      // console.log(privilegePayload);

      const privilegs = await stockAPI(
        privilegePayload,
        "POST",
        "/getCustomerPrivilegeVouchersList"
      );

      const locations = await stockAPI(
        locationPayload,
        "POST",
        "/getStoreLocations"
      );

      // console.log("location",locations);

      if (privilegs && locations?.locations) {
        let locationList = locations?.locations;
        let newLocation = [...this.state.locationData, ...locationList];
        this.setState(
          {
            privilegeData: privilegs ? privilegs : {},
            privilegeDataByLocation: privilegs ? privilegs : {},
            locationData: locations?.locations ? newLocation : {},
            // detailLocationData: locations?.locations ? newLocation : {},
          },
          () => {
            // Check for query params after data is fetched and state is updated
            this.checkQueryParamsForPrivilege();
          }
        );

        this.props.openLoader(false);
      } else {
        this.props.openLoader(false);
        // openAlertBox("Oops something went wrong!", "error");
      }
      this.setState({ privilegeLoaded: true });
    } else {
      this.props.openLoader(false);
      this.props.logout();
      this.setState({ privilegeLoaded: true });
    }
  }

  checkQueryParamsForPrivilege = () => {
    // Get the query parameters from the URL
    const idParam = this.props.location.pathname.split("/")[2];
    const shopIdParam = this.props.location.pathname.split("/")[3];

    // If there's an id parameter in the URL
    if (idParam) {
      // Find the privilege that matches the id
      const privilegeData = this.state.privilegeDataByLocation;
      let matchFound = false;

      // Loop through the privilege data to find a match
      if (Array.isArray(privilegeData)) {
        for (let i = 0; i < privilegeData.length; i++) {
          const privilege = privilegeData[i];

          // If the id matches, call handleInnerChange with the necessary data
          if (
            privilege.products_merchant_id === parseInt(idParam) ||
            privilege.products_merchant_id === idParam
          ) {
            // Create a synthetic event to pass to handleInnerChange
            const syntheticEvent = { stopPropagation: () => {} };

            // Call handleInnerChange with the necessary parameters
            const handleInnerChangeFunc = this.handleInnerChange(
              `innerPanel${i}`,
              privilege?.locations,
              `location${privilege.id}`
            );

            // Execute the returned function with the synthetic event and isExpanded=true
            handleInnerChangeFunc(syntheticEvent, true);

            // Set match found flag
            matchFound = true;

            // Break the loop since we found a match
            break;
          }
        }
      }
      // If no match was found, show a dialog
      if (!matchFound) {
        this.setState({
          dialogOpen: true,
          dialogMessage: "You are not eligible for this offer.",
        });
      }
      // Map shop id and call API for external scan logs
      if (shopIdParam) {
        this.setState({
          shopIdParam: shopIdParam,
        });
        this.callExternalLogsAPI(idParam, shopIdParam);
      }

      // Remove the query parameters from the URL
      this.removeQueryParams();
    }
  };

  callExternalLogsAPI = async (idParam, shopIdParam) => {
    const selectedBrand = this.state.privilegeData.find(
      (item) => item.products_merchant_id == idParam
    );

    if (selectedBrand) {
      const externalLogsPayload = new FormData();
      externalLogsPayload.append(
        "customer_id",
        getStorageItem("user") ? JSON.parse(getStorageItem("user")).id : 0
      );
      externalLogsPayload.append("product_merchant_id", idParam);
      externalLogsPayload.append("merchant_id", apiData.merchant_id);
      externalLogsPayload.append(
        "brand_id",
        selectedBrand ? selectedBrand.brand_id : 0
      );
      externalLogsPayload.append("scanned_at_brand", shopIdParam);
      const externalLogs = await stockAPI(
        externalLogsPayload,
        "POST",
        "/createExternalScanLogs"
      );
    }
  };
  setDefaultParam = async () => {
    if (getStorageItem("user")) {
      this.setState({
        customer_id: JSON.parse(getStorageItem("user")).id,
      });
    }

    if (getStorageItem("pointShortName")) {
      this.setState({
        pointShortName: getStorageItem("pointShortName"),
      });
    }
    if (getStorageItem("currencyCode")) {
      this.setState({
        currencyCode: getStorageItem("currencyCode"),
      });
    }
    if (getStorageItem("loyaltyId")) {
      this.setState({
        loyalty_id: getStorageItem("loyaltyId"),
      });
    }
    this.setState({
      platform: apiData.platform,
      merchant_id: apiData.merchant_id,
    });
  };
  // Method to handle closing the dialog
  handleCloseDialog = () => {
    this.setState({
      dialogOpen: false,
      dialogMessage: "",
    });
    this.props.history.push("/my-rewards");
  };

  // Method to remove query parameters from the URL
  removeQueryParams = () => {
    const { history, location } = this.props;

    // Create a new URL without query parameters
    const newUrl = location.pathname;

    // Replace the current URL with the new one (without query parameters)
    history.replace(newUrl);
  };

  openFilterDrawer = (e) => {
    e.stopPropagation();
    this.setState({
      filterDrawer: true,
    });
  };

  closeFilterDrawer = () => {
    this.setState({
      filterDrawer: false,
      isLoader: true,
      selectedLocationId: this.state.selectedLocationId,
      openLocation: false,
      innerExpanded: false,
      selectedIndex: this.state.selectedIndex,
    });
  };

  updatedAppliedFilterData = async () => {
    const { selectedIndex, selectedLocationId } = this.state;

    // Stop if no filter selected
    if (selectedIndex === undefined || selectedLocationId === undefined) {
      return;
    }

    this.setState({
      open: false,
      openLocation: false,
      innerExpanded: false,
    });

    // Get user data from storage
    const user = JSON.parse(getStorageItem("user"));
    const privilegePayload = new FormData();

    privilegePayload.append("customer_id", user.id);
    privilegePayload.append("platform", apiData.platform);
    privilegePayload.append("merchant_id", apiData.merchant_id);
    privilegePayload.append("status", selectedIndex);

    // Fetch privileges
    const privilegs = await stockAPI(
      privilegePayload,
      "POST",
      "/getCustomerPrivilegeVouchersList"
    );
    if (privilegs) {
      let updatedPrivilegeData = privilegs;

      if (selectedLocationId !== "all") {
        updatedPrivilegeData = privilegs.filter((data) =>
          data.locations.some((location) => location.id == selectedLocationId)
        );
      }

      // Set state with filtered data
      this.setState({
        privilegeData: privilegs || {},
        privilegeDataByLocation: updatedPrivilegeData || {},
      });
    }

    // Hide loader
    this.props.openLoader(false);
  };

  applyFilter = () => {
    this.setState(
      {
        filterDrawer: false,
        isLoader: true,
        appliedStatusId: this.state?.selectedIndex,
      },
      async () => {
        this.updatedAppliedFilterData();
      }
    );
  };

  resetFilter = () => {
    this.setState(
      {
        filterDrawer: false,
        isLoader: true,
        selectedLocationId: "all",
        openLocation: false,
        innerExpanded: false,
        selectedIndex: 1,
        appliedStatusId: 1,
      },
      async () => {
        this.updatedAppliedFilterData();
      }
    );
  };
  getBenefitTabData = async () => {
    if (getStorageItem("user")) {
      this.props.openLoader(true);
      let url =
        "/getStaticWebPage?platform=" +
        this.state.platform +
        "&merchant_id=" +
        this.state.merchant_id +
        "&page_type=" +
        302;
      var benefitData = await stockAPI({}, "GET", url);

      if (benefitData) {
        this.setState({
          benefits: benefitData,
        });
      }

      this.props.openLoader(false);
    } else {
      this.props.logoutUser();
    }
  };
  render() {
    const { classes } = this.props;
    const {
      // open,
      selectedIndex,
      locationData,
      // detailLocationData,
      selectedLocationId,
      selectedDetailLocationId,
      // openLocation,
      // openDetailLocation,
      benefits,
    } = this.state;
    // console.log(locationData);
    const userInfo = JSON.parse(getStorageItem("user"));

    return (
      // <div className={classes.root}>
      <div style={{ overflow: "auto", backgroundColor: globalBackground }}>
        <Loader open={!this.state.privilegeLoaded} />
        {this.state.privilegeLoaded &&
          this.state.privilegeDataByLocation.length == 0 && (
            <>
              <div
                style={{
                  border: `1px solid ${this.props.theme.palette.primary.main}`,

                  margin: "20px",
                }}
              >
                <LoyaltyInfo isPrivilegesPage />
              </div>
              <Grid
                className={classes.root}
                style={{ paddingRight: "20px", paddingLeft: "20px" }}
              >
                <Grid style={{ width: "100%" }}>
                  <div
                    className={
                      classes.content + " " + classes.benifit + " imgClass"
                    }
                    onClick={() => {
                      if (benefits) {
                        this.setState({ benefitsModalOpen: true });
                      }
                    }}
                    style={{ cursor: benefits ? "pointer" : "default" }}
                    dangerouslySetInnerHTML={{
                      __html: benefits ? benefits : "No data available.",
                    }}
                  ></div>
                </Grid>
              </Grid>
            </>
          )}

        {this.state.privilegeLoaded &&
          this.state.privilegeDataByLocation.length > 0 && (
            <div className={classes.privilegeRowWrapper}>
              <>
                <div className={classes.privilegeHeadBox}>
                  <StarBorderIcon className={classes.panelIcon} />
                  <b>
                    Privileges ({this.state.privilegeDataByLocation?.length}){" "}
                  </b>
                </div>
                <div>
                  {this?.state?.filterApplied ? (
                    <p
                      onClick={(e) => this?.openFilterDrawer(e)}
                      className={classes.filter_icon_container}
                    >
                      <span className={classes.filter_dot} />
                      <span
                        className={
                          classes.cardIcons + " " + classes.filterIconCss
                        }
                      />
                    </p>
                  ) : (
                    <span
                      className={
                        classes.filterIconCss + " " + classes.cardIcons
                      }
                      onClick={(e) => this?.openFilterDrawer(e)}
                    />
                  )}
                  {this.state.filterDrawer && (
                    <Drawer
                      anchor={"right"}
                      open={this.state.filterDrawer}
                      onClose={this.closeFilterDrawer}
                      variant="temporary"
                    >
                      <PrivilegeFilter
                        selectedLocationId={selectedLocationId}
                        allLocations={locationData}
                        onChangeHandler={this.handleMenuItemClickLocation}
                        handleApplyBtn={this.applyFilter}
                        handleResetBtn={this.resetFilter}
                        handleMenuItemClickLocation={
                          this.handleMenuItemClickLocation
                        }
                        status={options}
                        selectedStatus={selectedIndex}
                        handleStatusMenuItemClick={this.handleMenuItemClick}
                      />
                    </Drawer>
                  )}
                </div>
              </>
            </div>
          )}

        {/* {this.getPrvilegesList()} */}
        <div style={{ marginBottom: "85px" }}>
          {this.state.privilegeDataByLocation &&
            this.state.privilegeDataByLocation.map((data, index, arr) => {
              return (
                <div
                  key={data?.id || index}
                  className={`${classes.goldGradientBox} 
                  ${
                    data?.benefit_quantity_used === data?.benefit_quantity &&
                    data?.is_evoucher !== "1"
                      ? classes.disabled
                      : ``
                  } ${this.state.appliedStatusId == 0 ? classes.disabled : ``}
                `}
                  style={{ width: "95%", margin: "2%" }}
                >
                  <Accordion
                    expanded={this.state.innerExpanded === `innerPanel${index}`}
                    onChange={this.handleInnerChange(
                      `innerPanel${index}`,
                      data?.locations,
                      `location${data.id}`
                    )}
                    key={`innerPanel${index}`}
                    style={{ boxShadow: "none" }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                      className="leftArrow"
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        padding: "0px 8px 0px 8px",
                        // marginBottom: this.state.innerExpanded === `innerPanel${index}` ? "6px" : "0px",
                      }}
                    >
                      <Grid container>
                        <Grid item xs={3} sm={2} md={1}>
                          <img
                            src={data?.image_name}
                            className={classes.img}
                            alt="src-privilegeitem"
                          />
                        </Grid>
                        <Grid item xs={6} sm={8} md={9}>
                          <Typography
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            {data?.privilege_name}
                          </Typography>
                          {data?.expiry_date && (
                            <div className={classes.gradientChipWrapper}>
                              {/* <Chip
                              size="small"
                              label={`${data?.validity_period}`}
                              className={classes.validityPeriod}
                              style={{ fontSize: "13px", fontWeight: "500" }}
                            /> */}
                              {/* <Typography className={classes.expiryDate}>
                                Expires{" "}
                                {this.convertDate(data?.expiry_date) ===
                                "Invalid date"
                                  ? ""
                                  : this.convertDate(data?.expiry_date)}
                              </Typography> */}
                              <div
                                style={{
                                  border: `1px solid ${Theme.palette.primary.main}`,
                                  borderRadius: '14px',
                                  paddingRight: "9px",
                                  paddingLeft: "9px",
                                  paddingTop: "6px",
                                  paddingBottom: "6px",
                                }}
                              >
                                <Typography className={classes.expiryDate}>
                                  {/* Expires{" "} */}{data?.validity_period}
                                </Typography>
                              </div>
                            </div>
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          sm={2}
                          style={{
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <Typography className={classes.fontSizeResponsive}>
                            {" "}
                            {!data?.is_unlimited
                              ? `${data?.benefit_quantity_used}/${data?.benefit_quantity} Used`
                              : "Unlimited"}
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          xs={3}
                          sm={2}
                          md={1}
                          style={{ padding: 0 }}
                        />

                        <Grid
                          item
                          xs={9}
                          sm={10}
                          md={11}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 0,
                          }}
                        >
                          <p
                            className={`${classes.secondaryHeading} ${classes.fontSizeResponsive}`}
                            dangerouslySetInnerHTML={{
                              __html: truncateHTMLWithStructure(
                                data?.short_description,
                                this.state.innerExpanded ===
                                  `innerPanel${index}`
                                  ? 0
                                  : 40
                              ),
                            }}
                          ></p>
                          {/* <Typography
                            className={classes.fontSizeResponsive}
                            style={{ marginLeft: "10px" }}
                          >
                            {data?.locations[0]?.location_name}
                            {data?.locations?.length > 1
                              ? `+ ${data?.locations?.length - 1}`
                              : null}
                          </Typography> */}
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <div className={classes.panelDetail}>
                      <div
                        style={{
                          marginBottom:
                            data?.is_evoucher === "0" ? "10px" : "0px",
                        }}
                      ></div>

                      <div>
                        {data?.is_evoucher === "1" &&
                          data?.voucher_data?.length > 0 &&
                          (data?.is_unlimited ||
                            data?.voucher_data?.length > 1) && (
                            <Carousel
                              index={data?.voucher_data?.length - 1} // Start with the last item
                              indicators={data?.voucher_data?.length > 1}
                              cycleNavigation={false}
                              autoPlay={false}
                              NextIcon={<ChevronRightIcon />}
                              PrevIcon={<ChevronLeftIcon />}
                              navButtonsAlwaysVisible={
                                data?.voucher_data?.length > 1
                              }
                              className="qr-code-wrapper"
                              indicatorIconButtonProps={{
                                style: { color: "#bbb" },
                              }}
                              activeIndicatorIconButtonProps={{
                                style: { color: "#3077AC" },
                              }}
                              indicatorContainerProps={{
                                style: {
                                  marginTop: "20px",
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                },
                              }}
                              navButtonsWrapperProps={{
                                style: { height: "65%" },
                              }}
                              navButtonsProps={{
                                className: classes.navButton,
                              }}
                            >
                              {data?.voucher_data?.map((qrInfo, index) => {
                                const cleanVoucherCode =
                                  qrInfo?.voucher_code?.replace(
                                    /^[#$]+|[#$]+$/g,
                                    ""
                                  );
                                return (
                                  <div key={index}>
                                    <Paper
                                      style={{
                                        display: "inline-block",
                                        padding: "10px",
                                        backgroundColor: "#FFFFFF",
                                        margin: "0 auto",
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          textAlign: "center",
                                          width: "100%",
                                        }}
                                      >
                                        <QRCode
                                          size={154}
                                          value={`${qrInfo?.voucher_code}#${qrInfo?.voucher_pin}#${userInfo?.mobile_number}`}
                                        />
                                      </div>
                                    </Paper>
                                    <div
                                      style={{
                                        margin: "10px 0 20px 0",
                                      }}
                                    >
                                      {qrInfo?.voucher_code && (
                                        <p
                                          className={classes.numBox}
                                          style={{ margin: "5px 0" }}
                                        >
                                          Voucher code: {cleanVoucherCode}
                                        </p>
                                      )}
                                      {qrInfo?.voucher_pin && (
                                        <p
                                          className={classes.numBox}
                                          style={{ margin: "5px 0" }}
                                        >
                                          Voucher pin: {qrInfo?.voucher_pin}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </Carousel>
                          )}
                      </div>

                      {data?.is_evoucher == "0" && (
                        <Paper
                          elevation={0}
                          style={{
                            display: "inline-block",
                            padding: "10px",
                            backgroundColor: "#FFFFFF",
                            boxShadow: "none",
                          }}
                        >
                          {data?.privilege_type == "2" &&
                          this.state.shopIdParam ? (
                            <QRCode
                              size={154}
                              // value={
                              //   data?.benefit_quantity_used == data?.benefit_quantity ||
                              //   options[this.state.selectedIndex].val == 0
                              //     ? ""
                              //     : "https://google.com"
                              // }
                              // value={
                              //  "https://google.com"
                              // }
                              value={`${
                                window.location.origin
                              }/customer-privilege?customerId=${
                                userInfo.id
                              }&merchantId=${apiData.merchant_id}&mobileNo=${
                                userInfo.mobile_number
                              }&productId=${data?.products_merchant_id}&locId=${
                                selectedDetailLocationId ||
                                data?.locations[0].id
                              }&isUnlimited=${
                                data?.is_unlimited
                              }&privilegeType=${data?.privilege_type}&shopId=${
                                this.state.shopIdParam
                              }&brandId=${data?.brand_id}`}
                            />
                          ) : (
                            <QRCode
                              size={154}
                              // value={
                              //   data?.benefit_quantity_used == data?.benefit_quantity ||
                              //   options[this.state.selectedIndex].val == 0
                              //     ? ""
                              //     : "https://google.com"
                              // }
                              // value={
                              //  "https://google.com"
                              // }
                              value={`${
                                window.location.origin
                              }/customer-privilege?customerId=${
                                userInfo.id
                              }&merchantId=${apiData.merchant_id}&mobileNo=${
                                userInfo.mobile_number
                              }&productId=${data?.products_merchant_id}&locId=${
                                selectedDetailLocationId ||
                                data?.locations[0].id
                              }&isUnlimited=${
                                data?.is_unlimited
                              }&privilegeType=${data?.privilege_type}&brandId=${
                                data?.brand_id
                              }`}
                            />
                          )}
                        </Paper>
                      )}

                      <div style={{ marginBottom: "20px" }}></div>
                      {data?.is_evoucher === "1" &&
                        data?.showevoucherbtn === 1 && (
                          <>
                            {data?.is_unlimited ? (
                              <>
                                <p className={classes.secondaryHeading}>
                                  {parseInt(
                                    data?.benefit_quantity_used ?? "0"
                                  ) === 0
                                    ? "Click 'Get Voucher' to get your unique code and enjoy exclusive offers!"
                                    : "Click 'Get Remaining Voucher' to get another unique code!"}
                                </p>
                                <div className={classes.btnContainer}>
                                  <Button
                                    disableRipple
                                    color="primary"
                                    variant="contained"
                                    onClick={(e) =>
                                      this.handleGetEvoucherCode(e, [
                                        {
                                          product_merchant_id:
                                            data?.products_merchant_id,
                                          qty: 1,
                                          location_id:
                                            selectedDetailLocationId ||
                                            data?.locations?.[0]?.id,
                                          best_price: 0,
                                          calculated_points: 0,
                                        },
                                      ])
                                    }
                                  >
                                    {parseInt(
                                      data?.benefit_quantity_used ?? "0"
                                    ) === 0
                                      ? "Get Voucher"
                                      : "Get Remaining Voucher"}
                                  </Button>
                                </div>
                              </>
                            ) : (
                              // For limited vouchers
                              <>
                                {parseInt(data?.benefit_quantity_used ?? "0") <
                                  parseInt(data?.benefit_quantity ?? "0") && (
                                  <p className={classes.secondaryHeading}>
                                    {parseInt(
                                      data?.benefit_quantity_used ?? "0"
                                    ) === 0
                                      ? "Click 'Get Voucher' to instantly access your unique code and enjoy exclusive offers!"
                                      : `You have ${
                                          parseInt(
                                            data?.benefit_quantity ?? "0"
                                          ) -
                                          parseInt(
                                            data?.benefit_quantity_used ?? "0"
                                          )
                                        } more vouchers available!`}
                                  </p>
                                )}

                                {parseInt(data?.benefit_quantity_used ?? "0") <
                                  parseInt(data?.benefit_quantity ?? "0") && (
                                  <div className={classes.btnContainer}>
                                    <Button
                                      disableRipple
                                      color="primary"
                                      variant="contained"
                                      onClick={(e) =>
                                        this.handleGetEvoucherCode(e, [
                                          {
                                            product_merchant_id:
                                              data?.products_merchant_id,
                                            qty: 1,
                                            location_id:
                                              selectedDetailLocationId ||
                                              data?.locations?.[0]?.id,
                                            best_price: 0,
                                            calculated_points: 0,
                                          },
                                        ])
                                      }
                                    >
                                      {parseInt(
                                        data?.benefit_quantity_used ?? "0"
                                      ) === 0
                                        ? "Get Voucher"
                                        : `Get Remaining Voucher`}
                                    </Button>
                                  </div>
                                )}

                                {parseInt(data?.benefit_quantity_used ?? "0") >=
                                  parseInt(data?.benefit_quantity ?? "0") && (
                                  <p className={classes.secondaryHeading}>
                                    You've reached the maximum number of
                                    vouchers for this offer.
                                  </p>
                                )}
                              </>
                            )}
                          </>
                        )}
                    </div>
                  </Accordion>
                </div>
              );
            })}

          {/* No Privilege Page */}
          {/* <div style={{ marginBottom: "85px" }}>
            {this.state.privilegeLoaded &&
              this.state.privilegeDataByLocation.length == 0 && (
                <div
                  style={{
                    width: "95%",
                    margin: "2%",
                    alignItems: "center",
                    borderRadius: "5px",
                  }}
                >
                  <NoRecordFound message={"No Privileges found"} />
                </div>
              )}
          </div> */}
        </div>

        {/* <Accordion
            expanded={this.state.innerExpanded === "innerPanel3"}
            onChange={this.handleInnerChange("innerPanel3")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3bh-content"
              id="panel3bh-header"
            >
              <div className="privilege-item">
                <div className={classes.leftIcon}>
                  <ConfirmationNumberIcon />
                </div>
                <div className={classes.detail}>
                  <p>
                    <b>Movie Tickets</b>
                    <p className={classes.secondaryHeading}>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry
                    </p>
                  </p>
                </div>
                <div className={classes.secondaryHeading}>2/3 Available</div>
              </div>
            </AccordionSummary>
            <div className={classes.panelDetail}>
              <QRCode size={154} value={"https://google.com"} />
            </div>
          </Accordion> */}
        {/* <Accordion
            expanded={this.state.innerExpanded === "innerPanel4"}
            onChange={this.handleInnerChange("innerPanel4")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel4bh-content"
              id="panel4bh-header"
            >
              <div className="privilege-item">
                <div className={classes.leftIcon}>
                  <AssistantIcon />
                </div>
                <div className={classes.detail}>
                  <p>
                    <b>Personal Assistant</b>
                    <p className={classes.secondaryHeading}>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry
                    </p>
                  </p>
                </div>
                <div className={classes.secondaryHeading}>2/3 Available</div>
              </div>
            </AccordionSummary>
            <div className={classes.panelDetail}>
              <QRCode size={154} value={"https://google.com"} />
            </div>
          </Accordion> */}

        {/* Dialog for showing privilege not found message */}
        <Dialog
          open={this.state.dialogOpen}
          onClose={this.handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Privilege Unavailable"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Benefits detail modal */}
        <Dialog
          open={this.state.benefitsModalOpen}
          onClose={() =>
            this.setState({ benefitsModalOpen: false, benefitsZoom: 1 })
          }
          fullWidth
          maxWidth="md"
        >
          <DialogContent
            ref={(el) => {
              if (el && !el._zoomListenerAdded) {
                el._zoomListenerAdded = true;
                el.addEventListener(
                  "wheel",
                  (e) => {
                    e.preventDefault();
                    const delta = e.deltaY > 0 ? -0.1 : 0.1;
                    this.setState((prev) => ({
                      benefitsZoom: Math.min(
                        Math.max(prev.benefitsZoom + delta, 1),
                        3
                      ),
                    }));
                  },
                  { passive: false }
                );
              }
            }}
            style={{ overflow: "auto" }}
          >
            <div
              className={"imgClass"}
              style={{
                transform: `scale(${this.state.benefitsZoom})`,
                transformOrigin: "top left",
                transition: "transform 0.15s ease",
              }}
              dangerouslySetInnerHTML={{
                __html: benefits ? benefits : "",
              }}
            />
          </DialogContent>
          <DialogActions style={{ padding: "8px 24px 16px" }}>
            <Button
              onClick={() =>
                this.setState({ benefitsModalOpen: false, benefitsZoom: 1 })
              }
              variant="contained"
              color="primary"
              fullWidth
              style={{ color: "black" }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Privilege));
